import { render } from "./basedialogconfirm.vue?vue&type=template&id=0f17fc82&scoped=true"
import script from "./basedialogconfirm.vue?vue&type=script&lang=js"
export * from "./basedialogconfirm.vue?vue&type=script&lang=js"

import "./basedialogconfirm.vue?vue&type=style&index=0&id=0f17fc82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f17fc82"]])

export default __exports__